
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { record_type, int32_type, list_type, class_type, unit_type, option_type, lambda_type, string_type, bool_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { openDemoProjectFromPath, openFileInProject$0027, saveOpenFileToModel, getFileInProject, displayFileErrorNotification, openProjectFromPath, Constants_greenColor, Constants_boldStyle, Constants_blueColor, Constants_redColor, isFileInProject, allRootSheets, getSheetTreesFiltered, getSheetShapes, materialiseTree, SheetTree__lookupPath_7F866359, SheetTree_$reflection } from "./MenuHelpers.js";
import { Modifier_IModifier, Size_ISize, Color_IColor, Color_IColor_$reflection } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Model, ImportDecision, Msg, Msg_$reflection } from "../Model/ModelType.js";
import { CSSProp_Overflow_27AED5E3, DOMAttr, CSSProp, HTMLAttr, CSSProp_$reflection } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { button, Option, Option_$reflection } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { forAll as forAll_1, iterate, toArray as toArray_1, choose, cons, contains, find, filter, collect, item, tryFind, mapIndexed, last, sortBy, length, getSlice, map, fold, singleton, sumBy, isEmpty, append, ofArray, empty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { tryGetLoadedComponents, mapOverProject, CSSGridPos } from "./ModelHelpers.js";
import { containsKey, toList as toList_2, ofList as ofList_1, add, tryFind as tryFind_1, FSharpMap__get_Item } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { defaultArg, value as value_2 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { tryItem, forAll, exists, singleton as singleton_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { equalArrays, stringHash, defaultOf, equals, comparePrimitives } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { StringModule_Concat } from "../Common/EEExtensions.js";
import { ofList, toArray, count, toList as toList_1 } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { exportLibraryTo, findLibraries, LibraryHeader, Constants_defaultSection, Constants_currentFormatVersion, writeComponentFile, trySheetFileBody, tryUserLibrariesDirectory, customSheetsUsedBy, sheetFilePath, copySheetWithNewIds, reservedPrefixOf } from "../Interface/ComponentLibraries.js";
import { printf, toText, concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { isDigit, isLetterOrDigit } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { askForExistingSheetPathsAsync, askForFolder, tryEnsureDirectory, pathWithoutExtension, fileNameIsBad, tryLoadComponentFromPath, dirName, baseName, pathJoin, hasExtn, baseNameWithoutExtension, exists as exists_1 } from "../Interface/FilesIO.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { choicePopup, getText2, dialogPopupBodyTwoTexts, dialogPopupBodyOnlyText, dialogPopup, getText, getImportDecisions } from "../DrawBlock/PopupHelpers.js";
import { item as item_1, level } from "../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { parseDiagramSignatureFor } from "../Simulator/CanvasExtractor.js";
import { concat as concat_1, map as map_1, append as append_2 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { error, dbg, warn } from "../Shared/Log.js";
import { FSharpResult$2, Result_MapError, Result_Bind } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { successNotification } from "./Notifications.js";
import { helpText } from "./UIPopups.js";
import { Confirm_duplicateSheet } from "../Common/AppMessages.js";
import { Project } from "../Common/CommonTypes.js";
import { table as table_1 } from "../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { DrawModelType_SheetT_Msg } from "../Model/DrawModelType.js";

export class BreadcrumbConfig extends Record {
    constructor(AllowDuplicateSheets, ShowLibrarySheet, BreadcrumbIdPrefix, BreadcrumbText, ColorFun, ClickAction, ElementProps, ElementStyleProps, ButtonOptions, NoWaves, IsCollapsible, ExpandAction) {
        super();
        this.AllowDuplicateSheets = AllowDuplicateSheets;
        this.ShowLibrarySheet = ShowLibrarySheet;
        this.BreadcrumbIdPrefix = BreadcrumbIdPrefix;
        this.BreadcrumbText = BreadcrumbText;
        this.ColorFun = ColorFun;
        this.ClickAction = ClickAction;
        this.ElementProps = ElementProps;
        this.ElementStyleProps = ElementStyleProps;
        this.ButtonOptions = ButtonOptions;
        this.NoWaves = NoWaves;
        this.IsCollapsible = IsCollapsible;
        this.ExpandAction = ExpandAction;
    }
}

export function BreadcrumbConfig_$reflection() {
    return record_type("MiscMenuView.BreadcrumbConfig", [], BreadcrumbConfig, () => [["AllowDuplicateSheets", bool_type], ["ShowLibrarySheet", lambda_type(string_type, bool_type)], ["BreadcrumbIdPrefix", string_type], ["BreadcrumbText", option_type(lambda_type(SheetTree_$reflection(), string_type))], ["ColorFun", lambda_type(SheetTree_$reflection(), Color_IColor_$reflection())], ["ClickAction", lambda_type(SheetTree_$reflection(), lambda_type(lambda_type(Msg_$reflection(), unit_type), unit_type))], ["ElementProps", list_type(class_type("Fable.React.IHTMLProp"))], ["ElementStyleProps", list_type(CSSProp_$reflection())], ["ButtonOptions", list_type(Option_$reflection())], ["NoWaves", lambda_type(SheetTree_$reflection(), int32_type)], ["IsCollapsible", lambda_type(SheetTree_$reflection(), bool_type)], ["ExpandAction", lambda_type(SheetTree_$reflection(), lambda_type(lambda_type(Msg_$reflection(), unit_type), unit_type))]]);
}

export const Constants_gridBoxSeparation = "0 20px";

export const Constants_treeGap = "20px";

export const Constants_rootHierarchyClass = new HTMLAttr(/* ClassName */ 64, ["treeRoot"]);

export const Constants_defaultConfig = new BreadcrumbConfig(false, (_arg) => false, "BreadcrumbDefault", undefined, (_arg_1) => Color_IColor.IsGreyDark, (_arg_2, _arg_3) => {
}, empty(), empty(), ofArray([new Option(/* Size */ 1, [Size_ISize.IsSmall]), Option.IsOutlined, Option.IsExpanded, new Option(/* IsFocused */ 11, [true]), new Option(/* Disabled */ 16, [false])]), (_arg_4) => 0, (_arg_5) => false, (_arg_6, _arg_7) => {
});

export function gridBox(gap, s) {
    const props = [["style", {
        display: "inline-grid",
        gridGap: gap,
        justifyContent: "Start",
        "--tree-gap": Constants_treeGap,
    }]];
    return react.createElement("div", keyValueList(props, 1), ...s);
}

export function gridArea(gridPos_mut) {
    gridArea:
    while (true) {
        const gridPos = gridPos_mut;
        switch (gridPos.tag) {
            case 2: {
                const yStart = gridPos.fields[1] | 0;
                const xStart = gridPos.fields[0] | 0;
                gridPos_mut = (new CSSGridPos(/* PosAreaSpan */ 1, [xStart, yStart, (gridPos.fields[2] - xStart) + 1, (gridPos.fields[3] - yStart) + 1]));
                continue gridArea;
            }
            case 1:
                return `${gridPos.fields[1]} / ${gridPos.fields[0]} / span ${gridPos.fields[3]} / span ${gridPos.fields[2]}`;
            default: {
                gridPos_mut = (new CSSGridPos(/* PosAreaSpan */ 1, [gridPos.fields[0], gridPos.fields[1], 1, 1]));
                continue gridArea;
            }
        }
        break;
    }
}

/**
 * a Grid item centre justified and occupying given area
 */
export function gridElement(reactElementId, props, styleProps, pos, contents) {
    const props_1 = append(props, ofArray([new HTMLAttr(/* Id */ 99, [reactElementId]), ["style", keyValueList(append(styleProps, ofArray([new CSSProp(/* Display */ 125, ["flex"]), new CSSProp(/* FlexDirection */ 136, ["column"]), new CSSProp(/* TextAlign */ 325, ["center"]), new CSSProp(/* JustifySelf */ 201, ["center"]), new CSSProp(/* JustifyContent */ 200, ["center"]), new CSSProp(/* Width */ 395, ["100%"]), new CSSProp(/* Height */ 189, ["100%"]), new CSSProp(/* GridArea */ 169, [gridArea(pos)])])), 1)]]));
    return react.createElement("div", keyValueList(props_1, 1), ...contents);
}

export function positionTreeInGrid(tree) {
    const getTreeHeight = (tree_1) => {
        const matchValue = tree_1.SubSheets;
        if (isEmpty(matchValue)) {
            return 1;
        }
        else {
            return sumBy(getTreeHeight, matchValue, {
                GetZero: () => 0,
                Add: (x, y) => ((x + y) | 0),
            }) | 0;
        }
    };
    const getSheetPositions = (startX, startY, tree_2) => {
        const height = getTreeHeight(tree_2) | 0;
        const matchValue_1 = tree_2.SubSheets;
        if (isEmpty(matchValue_1)) {
            return singleton([new CSSGridPos(/* PosAreaSpan */ 1, [startX, startY, 1, height]), tree_2]);
        }
        else {
            return append(singleton([new CSSGridPos(/* PosAreaSpan */ 1, [startX, startY, 1, height]), tree_2]), fold((tupledArg, subSheet) => {
                const offset = tupledArg[0] | 0;
                return [offset + getTreeHeight(subSheet), append(tupledArg[1], getSheetPositions(startX + 1, startY + offset, subSheet))];
            }, [0, empty()], matchValue_1)[1]);
        }
    };
    return getSheetPositions(1, 1, tree);
}

export function positionDesignHierarchyInGrid(rootSheet, trees) {
    return positionTreeInGrid(FSharpMap__get_Item(trees, rootSheet));
}

export function positionRootAndFocusChildrenInGrid(root, pathToFocus, trees) {
    const tree = FSharpMap__get_Item(trees, root);
    const sheetsInPath = map((path) => value_2(SheetTree__lookupPath_7F866359(tree, path)), map((i) => getSlice(0, i, pathToFocus), toList(rangeDouble(0, 1, length(pathToFocus) - 1))));
    const children = sortBy((sheet) => sheet.BreadcrumbName, last(sheetsInPath).SubSheets, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    return mapIndexed((i_1, sheet_1) => [new CSSGridPos(/* PosAreaSpan */ 1, [length(sheetsInPath) + 1, 1, 1, length(children)]), sheet_1], children);
}

function gridSpan(pos) {
    switch (pos.tag) {
        case 2: {
            const y1 = pos.fields[1] | 0;
            return [pos.fields[0], y1, (pos.fields[3] - y1) + 1];
        }
        case 1:
            return [pos.fields[0], pos.fields[1], pos.fields[3]];
        default:
            return [pos.fields[0], pos.fields[1], 1];
    }
}

function connectorClasses(posL, pos) {
    const patternInput = gridSpan(pos);
    const y = patternInput[1] | 0;
    const x = patternInput[0] | 0;
    const h = patternInput[2] | 0;
    if (x <= 1) {
        return "treeCell";
    }
    else {
        const _arg = tryFind((tupledArg) => {
            const py = tupledArg[1] | 0;
            if ((tupledArg[0] === (x - 1)) && (py <= y)) {
                return (py + tupledArg[2]) >= (y + h);
            }
            else {
                return false;
            }
        }, map((arg) => gridSpan(arg[0]), posL));
        if (_arg != null) {
            const py_1 = _arg[1] | 0;
            const matchValue = py_1 === y;
            const matchValue_1 = (py_1 + _arg[2]) === (y + h);
            if (matchValue) {
                if (matchValue_1) {
                    return "treeCell treeNode treeOnly";
                }
                else {
                    return "treeCell treeNode treeFirst";
                }
            }
            else if (matchValue_1) {
                return "treeCell treeNode treeLast";
            }
            else {
                return "treeCell treeNode treeMiddle";
            }
        }
        else {
            return "treeCell";
        }
    }
}

export function makeGridFromSheetsWithPositions(cfg, dispatch, posL) {
    return gridBox(Constants_gridBoxSeparation, map((tupledArg) => {
        const pos = tupledArg[0];
        const sheet = tupledArg[1];
        const crumbId = (((cfg.BreadcrumbIdPrefix + ":") + sheet.SheetName) + ":") + StringModule_Concat(":", sheet.LabelPath);
        const number = cfg.NoWaves(sheet) | 0;
        const parentStub = isEmpty(sheet.SubSheets) ? empty() : singleton(react.createElement("div", {
            className: "treeStub",
        }));
        return gridElement(crumbId, append(cfg.ElementProps, singleton(new HTMLAttr(/* ClassName */ 64, [connectorClasses(posL, pos)]))), cfg.ElementStyleProps, pos, append(parentStub, singleton(button(ofArray([new Option(/* Props */ 17, [singleton(new HTMLAttr(/* Id */ 99, [crumbId]))]), new Option(/* Color */ 0, [cfg.ColorFun(sheet)]), new Option(/* Modifiers */ 20, [singleton(new Modifier_IModifier(/* TextColor */ 1, [Color_IColor.IsLight]))]), new Option(/* OnClick */ 18, [(ev) => {
            cfg.ClickAction(sheet, dispatch);
        }])]), toList(delay(() => {
            let matchValue_1, matchValue_3, path;
            return append_1(singleton_1((matchValue_1 = cfg.BreadcrumbText, (matchValue_3 = sheet.LabelPath, (matchValue_1 != null) ? matchValue_1(sheet) : (cfg.AllowDuplicateSheets ? (isEmpty(matchValue_3) ? sheet.SheetName : ((path = matchValue_3, item(length(path) - 1, path)))) : sheet.SheetName)))), delay(() => {
                let props_2, children_2;
                return append_1(cfg.IsCollapsible(sheet) ? singleton_1((props_2 = [["style", {
                    marginLeft: "6px",
                    fontWeight: "bold",
                }], new DOMAttr(/* OnClick */ 40, [(ev_1) => {
                    ev_1.stopPropagation();
                    cfg.ExpandAction(sheet, dispatch);
                }])], (children_2 = [equals(sheet.SubSheets, empty()) ? "+" : "−"], react.createElement("span", keyValueList(props_2, 1), ...children_2)))) : singleton_1(defaultOf()), delay(() => {
                    let props_4;
                    return (number > 0) ? singleton_1((props_4 = [["style", keyValueList([new CSSProp(/* Position */ 291, ["absolute"]), new CSSProp(/* Bottom */ 83, ["0px"]), new CSSProp(/* Right */ 298, ["0px"]), new CSSProp(/* BackgroundColor */ 21, ["transparent"]), new CSSProp(/* Width */ 395, ["20px"]), new CSSProp(/* Height */ 189, ["20px"]), new CSSProp(/* Display */ 125, ["flex"]), new CSSProp(/* AlignItems */ 1, ["center"]), new CSSProp(/* JustifyContent */ 200, ["center"]), new CSSProp(/* FontSize */ 153, ["10px"]), new CSSProp(/* Color */ 103, ["white"]), CSSProp_Overflow_27AED5E3("visible")], 1)]], react.createElement("div", keyValueList(props_4, 1), `${number}`))) : singleton_1(defaultOf());
                }));
            }));
        }))))));
    }, posL));
}

/**
 * display as a ReactElement the breadcrumbs.
 * clickAction - what happens when a given breadcrumb is clicked.
 * project - the model project.
 */
export function makeBreadcrumbsFromPositions(sheetTreeMap, cfg, positionSheetsInGrid, dispatch) {
    return makeGridFromSheetsWithPositions(cfg, dispatch, positionSheetsInGrid(sheetTreeMap));
}

/**
 * Draw a hierarchy that has already been built. The wave selector builds its own, because the
 * same tree decides what its other pane shows and the two must not be able to disagree.
 */
export function breadcrumbsOfTree(cfg, tree, dispatch) {
    return makeGridFromSheetsWithPositions(cfg, dispatch, positionTreeInGrid(tree));
}

/**
 * Breadcrumbs of entire simulated design hierarchy.
 * Display as a ReactElement the breadcrumbs.
 * ClickAction - what happens when a given breadcrumb (labelled by its path to root) is clicked.
 */
export function hierarchyBreadcrumbs(cfg, dispatch, model) {
    return mapOverProject(react.createElement("div", {}), model, (p) => {
        const root = defaultArg(model.WaveSimSheet, p.OpenFileName);
        return breadcrumbsOfTree(cfg, materialiseTree((_arg) => true, cfg.AllowDuplicateSheets, getSheetShapes(cfg.ShowLibrarySheet, p.LoadedComponents), root), dispatch);
    });
}

/**
 * Breadcrumbs of entire design hierarchy from given sheet
 * Display as a ReactElement the breadcrumbs.
 * rootSheet - root of hierrarchy displayed
 * clickAction - what happens when a given breadcrumb (labelled by its path to root) is clicked.
 */
export function hierarchyFromSheetBreadcrumbs(rootSheet, cfg, dispatch, model) {
    return mapOverProject(react.createElement("div", {}), model, (p) => makeBreadcrumbsFromPositions(getSheetTreesFiltered(cfg.ShowLibrarySheet, cfg.AllowDuplicateSheets, p), cfg, (trees) => positionDesignHierarchyInGrid(rootSheet, trees), dispatch));
}

/**
 * Breadcrumbs of entire design hierarchy of every root sheet in project
 * Display as a ReactElement the breadcrumbs.
 * rootSheet - root of hierrarchy displayed
 * clickAction - what happens when a given breadcrumb (labelled by its path to root) is clicked.
 */
export function allRootHierarchiesFromProjectBreadcrumbs(cfg, dispatch, model) {
    const rows = map((el) => react.createElement("div", keyValueList([Constants_rootHierarchyClass], 1), el), mapOverProject(singleton(react.createElement("div", {})), model, (p) => {
        const sheetTreeMap = getSheetTreesFiltered(cfg.ShowLibrarySheet, cfg.AllowDuplicateSheets, p);
        return map((root) => makeBreadcrumbsFromPositions(sheetTreeMap, cfg, (trees) => positionDesignHierarchyInGrid(root, trees), dispatch), toList_1(allRootSheets(sheetTreeMap)));
    }));
    return react.createElement("div", {}, ...rows);
}

/**
 * Breadcrumbs of the focus sheet, with sheets on its path to root, and its children.
 * Provides navigation while occupying small vertical area. Untested.
 * *** TODO: hookthis function to simulation and test ***
 * Should be called extracting inputs from waveform simulation.
 * Display as a ReactElement the breadcrumbs.
 * clickAction - what happens when a given breadcrumb (labelled by its path to root) is clicked.
 * project - the model project
 */
export function smallSimulationBreadcrumbs(rootName, pathToFocus, cfg, dispatch, model) {
    return mapOverProject(react.createElement("div", {}), model, (p) => makeBreadcrumbsFromPositions(getSheetTreesFiltered(cfg.ShowLibrarySheet, cfg.AllowDuplicateSheets, p), cfg, (trees) => positionRootAndFocusChildrenInGrid(rootName, pathToFocus, trees), dispatch));
}

/**
 * return a react warning message if name if not valid for a sheet Add or Rename, or else None
 */
export function maybeWarning(dialogText, project) {
    let option_1;
    const redText = (txt) => {
        let props;
        return (props = [["style", {
            color: "red",
        }]], react.createElement("div", keyValueList(props, 1), txt));
    };
    if (isFileInProject(dialogText, project)) {
        return redText("This sheet already exists.");
    }
    else if (reservedPrefixOf(project.LoadedComponents, dialogText) != null) {
        return redText(concat("Sheet names starting ", value_2(reservedPrefixOf(project.LoadedComponents, dialogText)), " belong to a component library used by this project."));
    }
    else if (dialogText.startsWith(" ") ? true : dialogText.endsWith(" ")) {
        return redText("The sheet name cannot start or end with a space.");
    }
    else if (exists((y) => ("." === y), dialogText.split(""))) {
        return redText("The sheet name cannot contain a file suffix.");
    }
    else if (!forAll((c) => {
        let ch;
        return ((ch = c, isLetterOrDigit(ch) ? true : (ch === "_"))) ? true : (c === " ");
    }, dialogText.split(""))) {
        return redText("The sheet name must contain only letters, digits, spaces or underscores");
    }
    else if (equals((option_1 = tryItem(0, dialogText.split("")), (option_1 != null) ? isDigit(option_1) : undefined), true)) {
        return redText("The name must not start with a digit");
    }
    else {
        return undefined;
    }
}

/**
 * Find all sheets that depend on the given sheet in the current project
 */
export function getDependentsFromSheet(model, sheetName) {
    return mapOverProject(undefined, model, (p) => collect((ldc_1) => collect((_arg) => {
        let matchResult, cid_1, ins_1, name_1, outs_1;
        if (_arg.Type.tag === 26) {
            if (_arg.Type.fields[0].Name === sheetName) {
                matchResult = 0;
                cid_1 = _arg.Id;
                ins_1 = _arg.Type.fields[0].InputLabels;
                name_1 = _arg.Type.fields[0].Name;
                outs_1 = _arg.Type.fields[0].OutputLabels;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return singleton([ldc_1.Name, cid_1, [ins_1, outs_1]]);
            default:
                return empty();
        }
    }, ldc_1.CanvasState[0]), filter((ldc) => (ldc.Name !== sheetName), p.LoadedComponents)));
}

/**
 * given paths from source directory and destination directory of a sheet that needs importing, if it exists in destination directory,
 * return its dependents wrapped in 'Some'. Otherwise return 'None'
 */
export function getDependents(model, oldSheetPath, newSheetPath) {
    if (exists_1(newSheetPath)) {
        const matchValue = getDependentsFromSheet(model, baseNameWithoutExtension(oldSheetPath));
        if (matchValue != null) {
            return StringModule_Concat(",", List_distinct(map((tupledArg) => tupledArg[0], matchValue), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }));
        }
        else {
            return "";
        }
    }
    else {
        return undefined;
    }
}

export function Button(sheetPath, buttonDecision, label, isDisabled, model, dispatch) {
    let valueOption;
    return singleton(button(ofArray([new Option(/* Size */ 1, [Size_ISize.IsSmall]), Option.IsOutlined, new Option(/* Color */ 0, [Color_IColor.IsPrimary]), new Option(/* Disabled */ 16, [isDisabled]), new Option(/* IsFocused */ 11, [(valueOption = tryFind_1(sheetPath, getImportDecisions(model.PopupDialogData)), (valueOption == null) ? false : equals(value_2(valueOption), buttonDecision))]), new Option(/* OnClick */ 18, [(_arg_1) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model$0027, _arg) => {
            dispatch(new Msg(/* UpdateImportDecisions */ 45, [add(sheetPath, buttonDecision, getImportDecisions(model$0027.PopupDialogData))]));
        }, dispatch]));
    }])]), singleton(label)));
}

/**
 * return text that should display in 'Action' column of import sheets popup
 */
export function getDecisionText(path, model, sheetIsDependency, decisionNeeded) {
    const matchValue = tryFind_1(path, getImportDecisions(model.PopupDialogData));
    if (matchValue == null) {
        if (sheetIsDependency ? true : decisionNeeded) {
            const props_8 = [["style", keyValueList([Constants_redColor], 1)]];
            return react.createElement("p", keyValueList(props_8, 1), "Ignore");
        }
        else {
            return react.createElement("p", {}, "Import");
        }
    }
    else {
        const decision = value_2(matchValue);
        if (decision == null) {
            const props_6 = [["style", keyValueList([Constants_redColor], 1)]];
            return react.createElement("p", keyValueList(props_6, 1), "Ignore");
        }
        else if (decision.tag === 1) {
            const props_4 = [["style", keyValueList([Constants_blueColor], 1)]];
            return react.createElement("p", keyValueList(props_4, 1), "Rename");
        }
        else if (sheetIsDependency) {
            return react.createElement("p", {}, "Import");
        }
        else {
            const props_2 = [["style", keyValueList([Constants_blueColor], 1)]];
            return react.createElement("p", keyValueList(props_2, 1), "Overwrite");
        }
    }
}

/**
 * return react element for 2 buttons that are side by side
 */
export function twoButtons(leftButton, rightButton) {
    return level(empty(), ofArray([item_1(empty(), leftButton), item_1(empty(), rightButton)]));
}

/**
 * prepare information that should display on a row for a dependency of a sheet
 */
export function dependencyRow(sheetPath, model, dispatch, dependencyPath) {
    let props, children, children_4, children_2, children_6, rightButton, children_8, props_12, children_12, children_18, children_14, props_16, children_24, props_22;
    if (hasExtn(".dgm", dependencyPath)) {
        const children_10 = [(props = [["style", keyValueList([Constants_boldStyle], 1)]], (children = [baseNameWithoutExtension(dependencyPath)], react.createElement("td", keyValueList(props, 1), ...children))), (children_4 = ["Dependency of ", (children_2 = [baseNameWithoutExtension(sheetPath)], react.createElement("strong", {}, ...children_2)), "."], react.createElement("td", {}, ...children_4)), (children_6 = [(rightButton = Button(dependencyPath, undefined, "Ignore", false, model, dispatch), twoButtons(Button(dependencyPath, ImportDecision.Overwrite, "Import", false, model, dispatch), rightButton))], react.createElement("td", {}, ...children_6)), (children_8 = [getDecisionText(dependencyPath, model, true, false)], react.createElement("td", {}, ...children_8))];
        return react.createElement("tr", {}, ...children_10);
    }
    else {
        const children_26 = [(props_12 = [["style", keyValueList([Constants_boldStyle], 1)]], (children_12 = [baseNameWithoutExtension(dependencyPath)], react.createElement("td", keyValueList(props_12, 1), ...children_12))), (children_18 = ["Dependency of ", (children_14 = [baseNameWithoutExtension(sheetPath)], react.createElement("strong", {}, ...children_14)), ".", (props_16 = [["style", keyValueList([Constants_redColor], 1)]], react.createElement("p", keyValueList(props_16, 1), "Doesn\'t exist in source and destination directories."))], react.createElement("td", {}, ...children_18)), react.createElement("td", {}, "N/A"), (children_24 = [(props_22 = [["style", keyValueList([Constants_redColor], 1)]], react.createElement("p", keyValueList(props_22, 1), "Ignore"))], react.createElement("td", {}, ...children_24))];
        return react.createElement("tr", {}, ...children_26);
    }
}

/**
 * for each imported sheet, create layout for its row in the popup table, as well as rows for all its dependencies.
 */
export function createSheetInfo(model, projectDir, dispatch, _arg1_, _arg1__1) {
    let children_8, props, children, children_32, props_20, children_20, children_26, children_28, rightButton, children_30, children_18, props_10, children_10, children_42, props_38, children_34, children_52, props_48, children_44, children_46, children_50;
    const _arg = [_arg1_, _arg1__1];
    const sheetPath = _arg[0];
    const dependencies = _arg[1];
    const newSheetPath = pathJoin([projectDir, baseName(sheetPath)]);
    const hasDependencies = count(dependencies) !== 0;
    let patternInput;
    const matchValue = getDependents(model, sheetPath, newSheetPath);
    patternInput = ((matchValue == null) ? [false, ""] : [true, matchValue]);
    const depSheets_1 = patternInput[1];
    if (projectDir === dirName(sheetPath)) {
        return [(children_8 = [(props = [["style", keyValueList([Constants_boldStyle], 1)]], (children = [baseNameWithoutExtension(sheetPath)], react.createElement("td", keyValueList(props, 1), ...children))), react.createElement("td", {}, "Cannot be imported as it is from the current directory"), react.createElement("td", {}, "N/A"), react.createElement("td", {}, "N/A")], react.createElement("tr", {}, ...children_8))];
    }
    else if (patternInput[0]) {
        const matchValue_1 = tryLoadComponentFromPath(sheetPath);
        if (matchValue_1.tag === 0) {
            const signatureOf = (ldc) => {
                const tupledArg = ldc.CanvasState;
                return parseDiagramSignatureFor(ldc.ArrayInfo, ldc.LCParameterSlots, tupledArg[0], tupledArg[1]);
            };
            const sourceSig = signatureOf(matchValue_1.fields[0]);
            const destSig = signatureOf(find((ldc_1) => (ldc_1.Name === baseNameWithoutExtension(sheetPath)), tryGetLoadedComponents(model)));
            const overwriteDisabled = !equalArrays(sourceSig, destSig) && (depSheets_1 !== "");
            return append_2([(children_32 = [(props_20 = [["style", keyValueList([Constants_boldStyle], 1)]], (children_20 = [baseNameWithoutExtension(sheetPath)], react.createElement("td", keyValueList(props_20, 1), ...children_20))), (children_26 = toList(delay(() => append_1(singleton_1("Sheet already exists in destination directory. "), delay(() => append_1(singleton_1(react.createElement("br", {})), delay(() => append_1(hasDependencies ? singleton_1("Sheet has dependencies.") : singleton_1(""), delay(() => append_1(singleton_1(react.createElement("br", {})), delay(() => {
                let props_26, props_28;
                return !equalArrays(sourceSig, destSig) ? ((depSheets_1 !== "") ? singleton_1((props_26 = [["style", keyValueList([Constants_redColor], 1)]], react.createElement("p", keyValueList(props_26, 1), "Overwrite disabled because sheets contain different hardware. Danger of conflicts in dependents."))) : singleton_1((props_28 = [["style", keyValueList([Constants_greenColor], 1)]], react.createElement("p", keyValueList(props_28, 1), "Sheets contain different hardware, but overwrite allowed as there are no dependents.")))) : singleton_1("");
            })))))))))), react.createElement("td", {}, ...children_26)), (children_28 = [(rightButton = Button(sheetPath, ImportDecision.Rename, "Rename", false, model, dispatch), twoButtons(Button(sheetPath, ImportDecision.Overwrite, "Overwrite", overwriteDisabled, model, dispatch), rightButton))], react.createElement("td", {}, ...children_28)), (children_30 = [getDecisionText(sheetPath, model, false, true)], react.createElement("td", {}, ...children_30))], react.createElement("tr", {}, ...children_32))], map_1((dependency) => dependencyRow(sheetPath, model, dispatch, dependency), toArray(dependencies)));
        }
        else {
            return [(children_18 = [(props_10 = [["style", keyValueList([Constants_boldStyle], 1)]], (children_10 = [baseNameWithoutExtension(sheetPath)], react.createElement("td", keyValueList(props_10, 1), ...children_10))), react.createElement("td", {}, matchValue_1.fields[0]), react.createElement("td", {}), react.createElement("td", {}, "Ignore")], react.createElement("tr", {}, ...children_18))];
        }
    }
    else if (fileNameIsBad(pathWithoutExtension(baseName(sheetPath)).split(""))) {
        return [(children_42 = [(props_38 = [["style", keyValueList([Constants_boldStyle], 1)]], (children_34 = [baseNameWithoutExtension(sheetPath)], react.createElement("td", keyValueList(props_38, 1), ...children_34))), react.createElement("td", {}, "Cannot be imported because it contains incorrect characters. "), react.createElement("td", {}), react.createElement("td", {}, "Ignore")], react.createElement("tr", {}, ...children_42))];
    }
    else {
        return append_2([(children_52 = [(props_48 = [["style", keyValueList([Constants_boldStyle], 1)]], (children_44 = [baseNameWithoutExtension(sheetPath)], react.createElement("td", keyValueList(props_48, 1), ...children_44))), (children_46 = toList(delay(() => (hasDependencies ? singleton_1("Sheet will be imported, but has dependencies.") : singleton_1("Sheet will be imported without conflicts")))), react.createElement("td", {}, ...children_46)), react.createElement("td", {}), (children_50 = [getDecisionText(sheetPath, model, false, false)], react.createElement("td", {}, ...children_50))], react.createElement("tr", {}, ...children_52))], map_1((dependency_1) => dependencyRow(sheetPath, model, dispatch, dependency_1), toArray(dependencies)));
    }
}

/**
 * Returns with a list of each path with its dependencies. This includes dependencies of dependencies
 */
export function pathsWithDependencies(destProjectDir, paths, sourceProjectDir) {
    return map((path) => {
        const search = (path_1, deps) => {
            const matchValue = tryLoadComponentFromPath(path_1);
            if (matchValue.tag === 0) {
                const customCompsPaths = filter((s) => (s !== ""), List_distinct(map((comp_1) => {
                    const matchValue_3 = comp_1.Type;
                    if (matchValue_3.tag === 26) {
                        return pathJoin([sourceProjectDir, matchValue_3.fields[0].Name + ".dgm"]);
                    }
                    else {
                        return "";
                    }
                }, filter((comp) => {
                    if (comp.Type.tag === 26) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }, matchValue.fields[0].CanvasState[0])), {
                    Equals: (x, y) => (x === y),
                    GetHashCode: (x) => (stringHash(x) | 0),
                }));
                if (length(customCompsPaths) === 0) {
                    return deps;
                }
                else {
                    return collect((dependencyPath_1) => {
                        if (exists_1(pathJoin([destProjectDir, baseName(dependencyPath_1)])) ? true : contains(dependencyPath_1, paths, {
                            Equals: (x_1, y_1) => (x_1 === y_1),
                            GetHashCode: (x_1) => (stringHash(x_1) | 0),
                        })) {
                            return search(dependencyPath_1, deps);
                        }
                        else if (exists_1(dependencyPath_1)) {
                            return search(dependencyPath_1, cons(dependencyPath_1, deps));
                        }
                        else {
                            return search(dependencyPath_1, cons(baseNameWithoutExtension(dependencyPath_1), deps));
                        }
                    }, customCompsPaths);
                }
            }
            else if (exists_1(pathJoin([destProjectDir, baseName(path_1)]))) {
                return deps;
            }
            else {
                return cons(baseNameWithoutExtension(path_1), deps);
            }
        };
        return [path, ofList(search(path, empty()), {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        })];
    }, paths);
}

/**
 * Copy the sheet file at oldPath into the current project under a name typed by the user.
 * nameOf turns the dialog text into the new sheet name: Import prefixes it, Duplicate uses it whole.
 * notes are extra lines displayed above the preview of the new name.
 * afterCopy is given the new sheet name and the current model, and decides how the project is reloaded.
 * Example: nameOf = (fun s -> s + "_adder"), text "old" -> sheet "old_adder" in file old_adder.dgm.
 */
export function copySheetIntoProjectPopup(title, placeholder, buttonText, notes, nameOf, oldPath, afterCopy, model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const newNameOf = (dialogData) => nameOf(getText(dialogData).toLocaleLowerCase());
        dialogPopup(title, (model_1) => dialogPopupBodyOnlyText((dialogData_1) => {
            const newName = newNameOf(dialogData_1);
            const children_2 = append(notes, ofArray([toText(printf("New name: %s"))(newName), defaultArg(maybeWarning(newName, project), react.createElement("div", {}))]));
            return react.createElement("div", {}, ...children_2);
        }, placeholder, dispatch, model_1), buttonText, (model$0027) => {
            const newName_1 = newNameOf(model$0027.PopupDialogData);
            copySheetWithNewIds(oldPath, sheetFilePath(project, newName_1));
            afterCopy(newName_1, model$0027);
            dispatch(Msg.ClosePopup);
        }, (model$0027_1) => {
            const newName_2 = newNameOf(model$0027_1.PopupDialogData);
            if ((getText(model$0027_1.PopupDialogData) === "") ? true : fileNameIsBad(newName_2.split(""))) {
                return true;
            }
            else {
                return !equals(maybeWarning(newName_2, project), undefined);
            }
        }, empty(), dispatch);
    }
    else {
        warn("copySheetIntoProjectPopup called when no project is currently open");
    }
}

/**
 * When sheet selected for import is from current directory,
 * show popup asking user to rename the file
 */
export function renameSheetBeforeImportPopup(oldPath, model, dispatch) {
    let arg;
    copySheetIntoProjectPopup("Duplicate sheet ", "Prefix for design sheet", "Rename", ofArray([(arg = baseName(oldPath), toText(printf("Warning: Sheet %s is from current directory."))(arg)), react.createElement("br", {}), react.createElement("br", {})]), (dialogText) => ((dialogText + "_") + baseNameWithoutExtension(oldPath)), oldPath, (_arg, model$0027) => {
        openProjectFromPath(dirName(oldPath), model$0027, dispatch);
    }, model, dispatch);
}

/**
 * Duplicate the named sheet of the current project under a new name typed by the user.
 * If that sheet is the open one it is saved to disk first when dirty, since the copy is made
 * from the file rather than from the canvas.
 * Save a sheet, and every sheet it uses, as components of a library.
 * 
 * The chosen sheet is offered in the catalogue; the sheets below it are written too but NOT
 * offered, since they exist only to serve it. That distinction used to be worked out by parsing
 * every sheet of a library to see which were instantiated by others; it is now simply recorded,
 * which is the point of having an authored header.
 * 
 * The body of each .ldgm is the text of the sheet's .dgm read straight off disk, so a library
 * component contains exactly what was saved. A sheet with unsaved changes is therefore refused
 * rather than quietly written in its last-saved state.
 */
export function saveAsLibraryComponent(sheetName, model, dispatch) {
    let list_4;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const byName = ofList_1(map((ldc) => [ldc.Name, ldc], project.LoadedComponents), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
        const closure = (seen, name) => {
            const matchValue_1 = contains(name, seen, {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: (x_1) => (stringHash(x_1) | 0),
            });
            const matchValue_2 = tryFind_1(name, byName);
            let matchResult;
            if (matchValue_1) {
                matchResult = 0;
            }
            else if (matchValue_2 != null) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
            }
            switch (matchResult) {
                case 0:
                    return seen;
                default: {
                    const ldc_1 = matchValue_2;
                    return fold(closure, append(seen, singleton(name)), customSheetsUsedBy(ldc_1));
                }
            }
        };
        const sheets = closure(empty(), sheetName);
        const unsaved = List_distinct((list_4 = filter((name_1) => {
            const matchValue_4 = tryFind_1(name_1, byName);
            if (matchValue_4 == null) {
                return false;
            }
            else {
                return matchValue_4.LoadedComponentIsOutOfDate;
            }
        }, sheets), append(((sheetName === project.OpenFileName) && model.SavedSheetIsOutOfDate) ? singleton(sheetName) : empty(), list_4)), {
            Equals: (x_2, y_2) => (x_2 === y_2),
            GetHashCode: (x_2) => (stringHash(x_2) | 0),
        });
        if (isEmpty(unsaved)) {
            dialogPopup(concat("Save ", sheetName, " as a library component"), (model_1) => dialogPopupBodyTwoTexts((_arg) => react.createElement("div", {}, "Library to put it in (an existing library, or a new name):"), "example: adders", (_arg_1) => react.createElement("div", {}, "What does this component do? This is what the catalogue shows:"), "example: ripple-carry adder, width set by a property", dispatch, model_1), "Save to library", (model$0027) => {
                const libName = getText(model$0027.PopupDialogData);
                const description = getText2(model$0027.PopupDialogData);
                const matchValue_7 = Result_Bind((root) => tryEnsureDirectory(pathJoin([root, libName])), tryUserLibrariesDirectory());
                if (matchValue_7.tag === 0) {
                    const matchValue_8 = choose((_arg_2) => {
                        if (_arg_2.tag === 0) {
                            return undefined;
                        }
                        else {
                            return _arg_2.fields[0];
                        }
                    }, map((name_2) => {
                        const ldc_3 = FSharpMap__get_Item(byName, name_2);
                        const matchValue_5 = trySheetFileBody(ldc_3.FilePath);
                        if (matchValue_5.tag === 0) {
                            return Result_MapError((msg_1) => concat(name_2, " could not be written: ", msg_1), writeComponentFile(matchValue_7.fields[0], new LibraryHeader(Constants_currentFormatVersion, name_2, (name_2 === sheetName) ? description : defaultArg(ldc_3.Description, name_2), Constants_defaultSection, name_2 === sheetName, customSheetsUsedBy(ldc_3)), matchValue_5.fields[0]));
                        }
                        else {
                            return new FSharpResult$2(/* Error */ 1, [concat(name_2, " could not be read: ", matchValue_5.fields[0])]);
                        }
                    }, sheets));
                    if (isEmpty(matchValue_8)) {
                        dispatch(new Msg(/* UpdateModel */ 41, [(m) => (new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, findLibraries(), m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, m.CurrentProj, m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState))]));
                        let alsoSaved;
                        const matchValue_9 = length(sheets) | 0;
                        alsoSaved = ((matchValue_9 === 1) ? "" : (` with ${matchValue_9 - 1} sheet(s) it uses`));
                        dispatch(new Msg(/* SetFilesNotification */ 79, [(dispatch_1) => successNotification(`${sheetName} saved to library ${libName}${alsoSaved}.`, Msg.CloseFilesNotification, dispatch_1)]));
                    }
                    else {
                        displayFileErrorNotification(StringModule_Concat(" ", matchValue_8), dispatch);
                    }
                }
                else {
                    displayFileErrorNotification(matchValue_7.fields[0], dispatch);
                }
                dispatch(Msg.ClosePopup);
            }, (model$0027_1) => {
                if (getText(model$0027_1.PopupDialogData) === "") {
                    return true;
                }
                else {
                    return getText2(model$0027_1.PopupDialogData) === "";
                }
            }, empty(), dispatch);
        }
        else {
            displayFileErrorNotification(concat("Save ", StringModule_Concat(", ", unsaved), " before making a library component: what is written is what is on disk."), dispatch);
        }
    }
    else {
        warn("A project must be open to save a sheet as a library component");
    }
}

/**
 * Copy a library out to a folder the user picks, as a subdirectory named after it - which is how
 * a library made in Issie is shared, backed up, or put under version control.
 * 
 * The folder is asked for rather than remembered: this is not somewhere Issie owns, and the last
 * place a library went is not a good guess at the next one.
 */
export function exportLibrary(library, dispatch) {
    const matchValue = askForFolder(concat("Where should the ", library.Name, " library be copied to?"), "Export here", undefined);
    if (matchValue != null) {
        const matchValue_1 = exportLibraryTo(matchValue, library);
        if (matchValue_1.tag === 0) {
            const result = matchValue_1.fields[0];
            const components = (result.Written === 1) ? "1 component" : (`${result.Written} components`);
            let alsoRemoved;
            const matchValue_2 = result.Removed | 0;
            alsoRemoved = ((matchValue_2 === 0) ? "" : ((matchValue_2 === 1) ? ", and removed 1 no longer in it" : (`, and removed ${matchValue_2} no longer in it`)));
            dispatch(new Msg(/* SetFilesNotification */ 79, [(dispatch_1) => successNotification(`${library.Name} exported to ${result.Destination}: ${components}${alsoRemoved}.`, Msg.CloseFilesNotification, dispatch_1)]));
        }
        else {
            displayFileErrorNotification(matchValue_1.fields[0], dispatch);
        }
    }
}

export function duplicateSheet(sheetName, model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const advice = helpText(Confirm_duplicateSheet);
        const matchValue_4 = getFileInProject(sheetName, project);
        let matchResult, sheet;
        if (matchValue_4 != null) {
            if (matchValue_4.Form != null) {
                if (matchValue_4.Form.tag === 0) {
                    matchResult = 0;
                    sheet = matchValue_4;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const notes = ofArray([toText(printf("Sheet \'%s\' will be duplicated as:"))(sheet.Name), react.createElement("br", {})]);
                if ((sheetName === project.OpenFileName) && model.SavedSheetIsOutOfDate) {
                    const matchValue_5 = saveOpenFileToModel(model);
                    let matchResult_1, p;
                    if (matchValue_5 != null) {
                        if (matchValue_5.CurrentProj != null) {
                            matchResult_1 = 0;
                            p = matchValue_5.CurrentProj;
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                    switch (matchResult_1) {
                        case 0: {
                            dispatch(new Msg(/* SetProject */ 39, [p]));
                            break;
                        }
                    }
                }
                choicePopup("Duplicate sheet", advice, "Continue", "Cancel", (isContinue, _arg) => {
                    dispatch(Msg.ClosePopup);
                    if (isContinue) {
                        copySheetIntoProjectPopup("Duplicate sheet", "New name for duplicated sheet", "Duplicate", notes, (x) => x, sheet.FilePath, (newName, model$0027) => {
                            const matchValue_1 = model$0027.CurrentProj;
                            const matchValue_2 = tryLoadComponentFromPath(pathJoin([project.ProjectPath, newName + ".dgm"]));
                            let matchResult_2, ldc, proj, err;
                            if (matchValue_1 != null) {
                                const copyOfStruct = matchValue_2;
                                if (copyOfStruct.tag === 1) {
                                    matchResult_2 = 1;
                                    err = copyOfStruct.fields[0];
                                }
                                else {
                                    matchResult_2 = 0;
                                    ldc = copyOfStruct.fields[0];
                                    proj = matchValue_1;
                                }
                            }
                            else {
                                const copyOfStruct_1 = matchValue_2;
                                if (copyOfStruct_1.tag === 1) {
                                    matchResult_2 = 1;
                                    err = copyOfStruct_1.fields[0];
                                }
                                else {
                                    matchResult_2 = 2;
                                }
                            }
                            switch (matchResult_2) {
                                case 0: {
                                    openFileInProject$0027(false, newName, new Project(proj.ProjectPath, proj.OpenFileName, proj.WorkingFileName, cons(ldc, proj.LoadedComponents)), model$0027, dispatch);
                                    break;
                                }
                                case 1: {
                                    displayFileErrorNotification(err, dispatch);
                                    break;
                                }
                                case 2: {
                                    break;
                                }
                            }
                        }, model, dispatch);
                    }
                }, dispatch);
                break;
            }
            case 1: {
                displayFileErrorNotification(concat("Sheet \'", sheetName, "\' cannot be duplicated."), dispatch);
                break;
            }
        }
    }
    else {
        warn("Current project must be open for a sheet to be duplicated");
    }
}

export function importSheetPopup(destProjectDir, paths, sourceProjectDir, dispatch) {
    const filterSheets = (existing) => filter((sheetPath) => {
        const newSheetPath = pathJoin([destProjectDir, baseName(sheetPath)]);
        if (!fileNameIsBad(baseNameWithoutExtension(baseName(sheetPath)).split(""))) {
            if (existing) {
                return exists_1(newSheetPath);
            }
            else {
                return !exists_1(newSheetPath);
            }
        }
        else {
            return false;
        }
    }, paths);
    dialogPopup("Resolve import conflicts", (model$0027) => {
        let children_4, children_2, children_6;
        const content = toArray_1(map((tupledArg) => createSheetInfo(model$0027, destProjectDir, dispatch, tupledArg[0], tupledArg[1]), pathsWithDependencies(destProjectDir, paths, sourceProjectDir)));
        const children_8 = [table_1(empty(), ofArray([(children_4 = [(children_2 = map((heading) => react.createElement("th", {}, heading), ofArray(["Sheet", "Information", "Decision", "Action"])), react.createElement("tr", {}, ...children_2))], react.createElement("thead", {}, ...children_4)), (children_6 = concat_1(content), react.createElement("tbody", {}, ...children_6))]))];
        return react.createElement("div", {}, ...children_8);
    }, "OK", (model$0027_1) => {
        const newSheetPaths = map((tupledArg_1) => {
            const sheetPath_2 = tupledArg_1[0];
            const decision = tupledArg_1[1];
            if (decision == null) {
                return [sheetPath_2, ""];
            }
            else if (decision.tag === 1) {
                return [sheetPath_2, pathJoin([destProjectDir, (baseNameWithoutExtension(sheetPath_2) + "_Copy") + ".dgm"])];
            }
            else {
                return [sheetPath_2, pathJoin([destProjectDir, baseName(sheetPath_2)])];
            }
        }, toList_2(getImportDecisions(model$0027_1.PopupDialogData)));
        iterate((oldSheetPath) => {
            copySheetWithNewIds(oldSheetPath, pathJoin([destProjectDir, baseName(oldSheetPath)]));
        }, filterSheets(false));
        iterate((tupledArg_2) => {
            const newSheetPath_2 = tupledArg_2[1];
            if (newSheetPath_2 === "") {
            }
            else {
                copySheetWithNewIds(tupledArg_2[0], newSheetPath_2);
            }
        }, newSheetPaths);
        dbg(128, concat("importing into ", destProjectDir));
        if (dirName(destProjectDir) === "demos") {
            openDemoProjectFromPath(destProjectDir, model$0027_1, dispatch);
        }
        else {
            openProjectFromPath(destProjectDir, model$0027_1, dispatch);
        }
        dispatch(Msg.ClosePopup);
        dispatch(Msg.FinishUICmd);
    }, (model$0027_2) => {
        let matchValue;
        return !((matchValue = filterSheets(true), isEmpty(matchValue) ? true : forAll_1((sheetPath_1) => containsKey(sheetPath_1, getImportDecisions(model$0027_2.PopupDialogData)), matchValue)));
    }, empty(), dispatch);
}

/**
 * Import sheet from directory, ask user to sort out dependency issues
 */
export function importSheet(model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const projectDir = matchValue.ProjectPath;
        dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* SetSpinner */ 33, [false])]));
        const pr = askForExistingSheetPathsAsync(model.UserData.LastUsedDirectory);
        void (pr.then((_arg) => {
            if (_arg != null) {
                const paths = _arg;
                const sourceProjectDir = dirName(item(0, paths));
                iterate((path) => {
                    if (projectDir === sourceProjectDir) {
                        renameSheetBeforeImportPopup(path, model, dispatch);
                    }
                    else {
                        const matchValue_2 = saveOpenFileToModel(model);
                        let matchResult, p;
                        if (matchValue_2 != null) {
                            if (matchValue_2.CurrentProj != null) {
                                matchResult = 0;
                                p = matchValue_2.CurrentProj;
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                        switch (matchResult) {
                            case 0: {
                                dispatch(new Msg(/* SetProject */ 39, [p]));
                                break;
                            }
                        }
                        importSheetPopup(projectDir, paths, sourceProjectDir, dispatch);
                    }
                }, paths);
            }
        }).catch((err) => {
            error(err.message);
        }));
    }
    else {
        warn("Current project must be open for sheet to be imported to it");
    }
}

